import * as React from 'react';
type Props = {
  className?: string;
};
export function CaretDown({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-caret-down"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2426 8.5L17.6568 9.91421L12 15.5711L6.34314 9.91421L7.75735 8.5L12.0001 12.742L16.2426 8.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
